import { useMemo } from "react";

import { yupLocalized } from "@ryde/shared";

import { IQuickAddStationFormModel } from "./quick-add-station-form.models";

export const useQuickAddValidationSchema = () => {
  const quickAddStationFormValidationRules = useMemo(() => {
    return yupLocalized.object<IQuickAddStationFormModel>().shape({
      areaId: yupLocalized.number().required(""),
      coordinate: yupLocalized
        .object()
        .shape({
          lat: yupLocalized.number().required(),
          lng: yupLocalized.number().required(),
        })
        .required(),
      address: yupLocalized
        .object()
        .shape({
          placeId: yupLocalized.string().required(),
        })
        .required(),
    });
  }, []);
  return { quickAddStationFormValidationRules };
};
